module.exports = "https://static.energy5.com/_next/static/images/device-e518263c47a9b815a16c3aad1dddd8cb.png";